import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalSizeEnum } from '../../../../enum/modal-size.enum';
import { SmsTemplateEntity } from '../../../../models/entity/sms/sms-template-entity';
import { SendSmsPreviewRequest } from '../../../../models/rest/sms/send-sms-preview-request';
import { DeviceLocalStorageData } from '../../../../models/rest/user/device-local-storage-data.model';
import { SmsTemplateSelectModalComponent } from '../../../../pages/sms/sms-template-select-modal/sms-template-select-modal.component';
import { AlertifyService } from '../../../../services/core/alertify.service';
import { CommunicationService } from '../../../../services/core/communication.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { StringUtils } from '../../../../utils/string.utils';

import { SmsService } from '../../../../services/sms/sms.service';

@Component({
  selector: 'app-whatsapp-widget',
  templateUrl: './whatsapp-widget.component.html',
  styleUrls: ['./whatsapp-widget.component.css']
})
export class WhatsappWidgetComponent implements OnInit {
  @Input() customerId: number;
  @Input() orderId: number;
  @Input() phoneNumber: string;
  deviceLocalStorageData: DeviceLocalStorageData;
  constructor(
    private modalService: NgbModal,
    private smsService: SmsService,
    private translate: TranslateService,
    private alertifyService: AlertifyService,
    private sessionStorageService: SessionStorageService,
    private communicationService: CommunicationService) { }

  ngOnInit(): void {
    this.deviceLocalStorageData = this.sessionStorageService.getDeviceStorageData();
  }

  validateSave() {
    if (StringUtils.isEmpty(this.phoneNumber)) {
      this.alertifyService.warning(this.translate.instant("message.error.phone-number-cannot-be-blank"))
      return false;
    }

    return true;
  }

  openWhatsApp() {

    if (!this.validateSave()) return;

    this.openSmsTemplateSelectModal();
  }

  openSmsTemplateSelectModal() {

    const modalRef = this.modalService.open(SmsTemplateSelectModalComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE
    });

    if (this.orderId != undefined) {
      modalRef.componentInstance.showAlsoOrderTemplates = true;
    }

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe(async (receivedEntry: SmsTemplateEntity) => {
      // Cevap boş değilse
      if (receivedEntry) {
        if (this.customerId == undefined) {
          this.communicationService.openWhatsApp(this.phoneNumber, receivedEntry.message ?? "");
          // modal kapat
          modalRef.close();
          return;
        }
        let previewRequest = new SendSmsPreviewRequest();
        previewRequest.smsMessageType = receivedEntry.usageFor;
        previewRequest.message = receivedEntry.message;
        previewRequest.customerId = this.customerId;
        previewRequest.orderId = this.orderId;
        try {
          const res = await this.smsService.getSmsPreview(previewRequest).toPromise();
          this.communicationService.openWhatsApp(this.phoneNumber, res!.message!);
        }
        catch (err) {
          this.alertifyService.error(err);
        }
      }
      else {

        this.communicationService.openWhatsApp(this.phoneNumber, "");
      }
      // Şablon seçilmediğinde burada WhatsApp açılmaz, sadece modal kapanır

      // modal kapat
      modalRef.close();
    });

    // Modal kapatıldığında sadece şablon seçilmediyse WhatsApp aç
    modalRef.result.then(
      (success) => {
        // Şablon seçildiyse buraya gelmez, zaten subscribe'da açıldı
      },
      (cancel) => {
        // Şablon seçilmediyse burada WhatsApp aç
        this.communicationService.openWhatsApp(this.phoneNumber, "");
      }
    );

  }

}
